export default __webpack_public_path__ + "static/media/home-active.c1abcab1.svg";